var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import * as R from 'ramda';
import { FormBaseElement, } from '@unitarius/xbpm-runtime';
import { mapElementClass } from '../../common';
import { ControlError } from './ControlError';
import { Button } from 'primereact/button';
var CameraControl = /** @class */ (function (_super) {
    __extends(CameraControl, _super);
    function CameraControl(props) {
        var _this = _super.call(this, props) || this;
        _this.resizeElements = function () {
            var videoWidth = _this.videoRef.current.clientWidth;
            var videoHeight = _this.videoRef.current.clientHeight;
            if (!!videoWidth && !!videoHeight) {
                var width = (_this.videoSizes.width * videoHeight) / _this.videoSizes.height;
                width = width > videoWidth ? videoWidth : width;
                var height = (videoWidth * _this.videoSizes.height) / _this.videoSizes.width;
                height = height > videoHeight ? videoHeight : height;
                if (_this.markupRef.current) {
                    _this.markupRef.current.setAttribute('style', "width: " + (width - 120) + "px; height: " + (height - 100) + "px");
                }
                _this.imgRef.current.setAttribute('style', "width: " + width + "px; height: " + height + "px");
                var buttonSizeH = videoWidth > 750 ? 120 : videoWidth / 10;
                var buttonSizeV = videoHeight > 600 ? 120 : videoHeight / 8;
                var buttonSize = buttonSizeH > buttonSizeV ? buttonSizeV : buttonSizeH;
                _this.setState(__assign(__assign({}, _this.state), { buttonSize: buttonSize }), _this.forceUpdate);
            }
        };
        _this.setError = function (errorText, hideError) {
            if (errorText === void 0) { errorText = null; }
            if (hideError === void 0) { hideError = true; }
            _this.setState({ errorText: errorText }, _this.forceUpdate);
            if (hideError && !!errorText) {
                setTimeout(function () {
                    _this.setError();
                }, 5000);
            }
        };
        _this.toggleImgSrc = function (src) {
            _this.setState(__assign(__assign({}, _this.state), { imgSrc: src }), _this.forceUpdate);
        };
        _this.checkQuality = function (src, resolution) {
            var imgHead = 'data:image/png;base64,';
            var minResolutionWidth = R.path(['def', 'frontOptions', 'minResolutionWidth'], _this.state);
            var minResolutionHeight = R.path(['def', 'frontOptions', 'minResolutionHeight'], _this.state);
            var minSize = R.path(['def', 'frontOptions', 'minSize'], _this.state);
            var maxSize = R.path(['def', 'frontOptions', 'maxSize'], _this.state);
            var size = Math.round(((src.length - imgHead.length) * 3) / 4 / 1024);
            var result = 'ok';
            if ((!!minSize && minSize > size) ||
                (!!minResolutionWidth && minResolutionWidth > resolution.width) ||
                (!!minResolutionHeight && minResolutionHeight > resolution.height)) {
                _this.setError('Увеличьте разрешение или воспользуйтесь другим устройством');
                result = 'less';
            }
            else if (!!maxSize && maxSize < size) {
                result = 'more';
            }
            return result;
        };
        _this.makePhoto = function () {
            var _a = _this.videoSizes, width = _a.width, height = _a.height;
            _this.canvasRef.current.width = width;
            _this.canvasRef.current.height = height;
            _this.canvasRef.current.getContext('2d').drawImage(_this.videoRef.current, 0, 0);
            var quality = R.pathOr(1, ['def', 'frontOptions', 'quality'], _this.state);
            var dataURL = _this.canvasRef.current.toDataURL('image/jpeg', quality);
            while (_this.checkQuality(dataURL, { width: width, height: height }) === 'more') {
                quality *= 0.9;
                dataURL = _this.canvasRef.current.toDataURL('image/jpeg', quality);
            }
            if (_this.checkQuality(dataURL, { width: width, height: height }) === 'ok') {
                _this.toggleImgSrc(dataURL);
            }
        };
        _this.uploadPhoto = function () { return __awaiter(_this, void 0, void 0, function () {
            var url, formData, blob, response, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = R.path(['def', 'frontOptions', 'url'], this.state);
                        if (!!!this.state.imgSrc) return [3 /*break*/, 5];
                        formData = new FormData();
                        return [4 /*yield*/, new Promise(function (resolve) { return _this.canvasRef.current.toBlob(resolve, 'image/jpeg'); })];
                    case 1:
                        blob = (_a.sent());
                        formData.append('file', blob, 'photo.jpg');
                        return [4 /*yield*/, fetch(url, {
                                method: 'POST',
                                headers: this.headers,
                                body: formData,
                            })];
                    case 2:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 4];
                        return [4 /*yield*/, response.json()];
                    case 3:
                        result = _a.sent();
                        if (result.some(function (r) { return r.error; })) {
                            return [2 /*return*/, this.setError('При загрузке файла произошла ошибка')];
                        }
                        this.handleChange(result);
                        this.setState({ showSuccessMsg: true });
                        setTimeout(function () {
                            _this.toggleImgSrc();
                            _this.setState({ showSuccessMsg: false });
                        }, 3000);
                        return [3 /*break*/, 5];
                    case 4:
                        this.setError('При загрузке файла произошла ошибка');
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.resetPhoto = function () {
            _this.toggleImgSrc();
            _this.handleChange(null);
        };
        _this.state = __assign(__assign({}, _this.state), { buttonSize: 120, showSuccessMsg: false });
        _this.videoRef = React.createRef();
        _this.canvasRef = React.createRef();
        _this.imgRef = React.createRef();
        _this.markupRef = React.createRef();
        _this._isMount = false;
        return _this;
    }
    CameraControl.prototype.componentDidUpdate = function (_, prevState) {
        var _this = this;
        if (!!this.state.def && !R.eqBy(R.path(['def', 'hidden']), this.state, prevState)) {
            if (!R.path(['def', 'hidden'], this.state)) {
                this._isMount = true;
                if (this._isMount) {
                    if (!!navigator.mediaDevices && !!navigator.mediaDevices.getUserMedia) {
                        navigator.mediaDevices
                            .getUserMedia({ video: true })
                            .then(function (stream) {
                            if (!!_this.videoRef && !!_this.videoRef.current) {
                                _this.videoRef.current.srcObject = stream;
                                setTimeout(_this.resizeElements, 500);
                            }
                        })
                            .catch(function (err) {
                            if (err.code === 0) {
                                _this.setError('Доступ к камере запрещён', false);
                            }
                        });
                    }
                }
                window.addEventListener('resize', this.resizeElements);
            }
            else {
                this._isMount = false;
                if (!!this.videoRef.current.srcObject) {
                    var tracks = this.videoRef.current.srcObject.getTracks();
                    tracks.forEach(function (track) {
                        if (track.kind === 'video') {
                            track.stop();
                        }
                    });
                    this.videoRef.current.srcObject = null;
                }
                window.removeEventListener('resize', this.resizeElements);
            }
        }
    };
    CameraControl.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        window.removeEventListener('resize', this.resizeElements);
    };
    Object.defineProperty(CameraControl.prototype, "headers", {
        get: function () {
            var headers = R.path(['def', 'frontOptions', 'headers'], this.state);
            return headers && typeof headers === 'object' ? headers : {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CameraControl.prototype, "videoSizes", {
        get: function () {
            var width = R.pathOr(0, ['current', 'videoWidth'], this.videoRef);
            var height = R.pathOr(0, ['current', 'videoHeight'], this.videoRef);
            return { width: width, height: height };
        },
        enumerable: false,
        configurable: true
    });
    CameraControl.prototype.elementRender = function (def) {
        var _this = this;
        var frontOptions = def.frontOptions;
        return (React.createElement("div", { className: mapElementClass(frontOptions), style: { display: def.hidden ? 'none' : 'block' } },
            React.createElement("label", null, def.label),
            React.createElement("div", { className: frontOptions.className, style: frontOptions.style },
                React.createElement("div", { className: "camera-block", style: { position: 'relative' } },
                    React.createElement("video", { autoPlay: true, ref: this.videoRef, style: { width: '100%', height: window.innerHeight - 200 } }),
                    React.createElement("img", { ref: this.imgRef, className: "center-block", src: this.state.imgSrc, alt: "Photo", height: "100%" }),
                    this.state.showSuccessMsg ? (React.createElement("div", { className: "foto-success-block", style: { backgroundColor: '#fff', zIndex: 1 } },
                        React.createElement("div", { className: "center-block column" },
                            React.createElement("p", null, "\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u044F \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u0430")))) : !!this.state.errorText ? (React.createElement("div", { className: "foto-success-block" },
                        React.createElement("div", { className: "center-block column" },
                            React.createElement("p", null, this.state.errorText)))) : (React.createElement("div", { ref: this.markupRef, className: "markup" },
                        React.createElement("div", { className: "markup-angle top left" }),
                        React.createElement("div", { className: "markup-angle top rigth" }),
                        React.createElement("div", { className: "markup-angle bottom left" }),
                        React.createElement("div", { className: "markup-angle bottom rigth" }),
                        this.state.imgSrc ? (React.createElement("div", { className: "center-block" },
                            React.createElement(Button, { icon: "fas fa-download", onClick: this.uploadPhoto, className: "p-button-link foto-button", style: { fontSize: this.state.buttonSize + 'px' } }),
                            React.createElement(Button, { icon: "fas fa-times", onClick: function () { return _this.toggleImgSrc(); }, className: "p-button-link foto-button", style: { fontSize: this.state.buttonSize + 'px' } }))) : (React.createElement("div", { className: "center-block", style: { justifyContent: 'space-around' } },
                            React.createElement(Button, { icon: "fas fa-camera", onClick: this.makePhoto, className: "p-button-link foto-button", style: { fontSize: this.state.buttonSize + 'px' } })))))),
                React.createElement("canvas", { ref: this.canvasRef, style: { display: 'none' } })),
            React.createElement(ControlError, { error: this.error, touched: this.touched })));
    };
    return CameraControl;
}(FormBaseElement));
export { CameraControl };
//# sourceMappingURL=Camera.js.map